// src/services/authService.js
import axios from 'axios';
import Cookies from 'js-cookie';

const API_KEY = process.env.REACT_APP_API_KEY;
const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

export const loginApi = async (email, password) => {
  try {
    const loginPayload = {
      email,
      password,
      grant_type: 'password',
    };

    const response = await axios.post(`${BASE_URL_BE}/auth/login`, loginPayload, {
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    });

    const { data } = response.data;
    if (data.token) {
      Cookies.set('access_token', data.token, { expires: 1 }); // Simpan token ke cookie
    }

    return response.data;
  } catch (error) {
    console.error("Login service error:", error);
    throw error;
  }
};

export const changePassword = async (secret, password, confirm_password) => {
  try {
    const loginPayload = {
      secret,
      password,
      confirm_password,
      grant_type: 'reset',
    };

    const response = await axios.put(`${BASE_URL_BE}/auth/reset-password/direct`, loginPayload, {
      headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    });

    return response.data;
  } catch (error) {
    console.error("Login service error:", error);
    throw error;
  }
};

export const verifikasiSecret = async (secret) => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}/user/verifikasi?secret=${secret}`,
      {}, // body kosong karena tidak perlu
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': API_KEY,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Verifikasi secret error:", error);
    throw error;
  }
};
